import React, { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { Button, Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, Spacer, Text } from '@chakra-ui/react'
import { AiOutlineMenu } from 'react-icons/ai'
import { FiLock } from 'react-icons/fi'
import { GoChevronDown } from 'react-icons/go'
import { RiLockPasswordFill } from 'react-icons/ri'

import { authSelector, logout } from '@/stores/auth/authSlice'
import { toggleSidebar } from '@/stores/ui/uiSlice'
import { useNavigate } from 'react-router-dom'

import config, { APP_MODE } from '@/config'
import { useTranslation } from 'react-i18next'
import { FaGlobe } from 'react-icons/fa'
import storage from '@/utils/storage'

const Header = () => {
  const { user } = useSelector(authSelector)
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const isProduction = config.mode == APP_MODE.PRODUCTION

  // Load saved language on mount
  useEffect(() => {
    const savedLanguage = storage.getLanguage()
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage)
    }
  }, [])

  const handleLogout = () => {
    dispatch(logout())

    queryClient.clear()
    navigate(isProduction ? '/auth/login' : '/external/auth/login')
  }

  const resetLanguage = (value) => {
    i18n.changeLanguage(value)
    console.log('value', value)
    storage.setLanguage(value)
  }

  const handelResetPassword = () => {
    if (!user?._id) {
      toast.error('[Unexpected Error] Missing User Id !')
      return
    }
    navigate(isProduction ? `/users/newPassword?id=${user?._id}` : `/external/users/newPassword?id=${user?._id}`)
  }

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar())
  }
  return (
    <Flex basis="65px" borderBottom="1px solid #d8dbe0" align="center" pl="8">
      <IconButton
        variant="ghost"
        aria-label="Toggle Sidebar"
        icon={<AiOutlineMenu size={20} />}
        onClick={handleToggleSidebar}
      />
      <Spacer />
      {config.mode !== APP_MODE.PRODUCTION && <Text color="red">({config.mode})</Text>}

      <Menu zIndex={'dropdown'} strategy="fixed">
        <MenuButton as={Button} variant="ghost" rightIcon={<FaGlobe />}>
          {t('HEADER_LANGUAGE')}
        </MenuButton>
        <MenuList>
          <MenuItem as={Button} variant="ghost" onClick={() => resetLanguage('en')}>
            {t('HEADER_LANGUAGE_OPTION_ENGLISH')}
          </MenuItem>
          <MenuItem as={Button} variant="ghost" onClick={() => resetLanguage('zh')}>
            {t('HEADER_LANGUAGE_OPTION_TRADITIONAL_CHINESE')}
          </MenuItem>
          <MenuItem as={Button} variant="ghost" onClick={() => resetLanguage('cn')}>
            {t('HEADER_LANGUAGE_OPTION_SIMPLIFIED_CHINESE')}
          </MenuItem>
        </MenuList>
      </Menu>

      <Menu zIndex={'dropdown'} strategy="fixed">
        <MenuButton as={Button} variant="ghost" rightIcon={<GoChevronDown />}>
          {t('HEADER_GREETING')}, {user?.fullName}
        </MenuButton>
        <MenuList>
          <MenuItem as={Button} variant="ghost" leftIcon={<FiLock />} onClick={handleLogout}>
            {t('HEADER_LOG_OUT')}
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}

export default Header
